/*
 * @Author: lc
 * @Date: 2023-10-07 12:04:00
 * @LastEditors: lc
 * @LastEditTime: 2026-08-26 17:38:10
 * @FilePath: \vue3androuter\src\router\index.ts
 * @Description: 
 */
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/HomeView',
    name: 'HomeView',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/callBody',
    name: 'callBody',
    component: () => import('../views/callBody.vue')
  },
  {
    path: '/callBody2',
    name: 'callBody2',
    component: () => import('../views/callBody2.vue')
  },
  {
    path: '/callBody3',
    name: 'callBody3',
    component: () => import('../views/callBody3.vue')
  },
  {
    path: '/',
    name: 'awaitAdverse',
    component: () => import('../views/awaitAdverse.vue')
  },
  {
    path: '/smartHealthInsurance',
    name: 'smartHealthInsurance',
    meta: {
      title: '智慧医保',
    },
    component: () => import('../views/smartHealthInsurance.vue')
  },
  {
    path: '/wait',
    name: 'wait',
    meta: {
      title: '等待',
    },
    component: () => import('../views/wait.vue')
  },
  {
    path: '/waitNew',
    name: 'waitNew',
    meta: {
      title: '等待',
    },
    component: () => import('../views/waitNew.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
// 设置文档标题的函数
function setPageTitle(title: string) {
  document.title = title ? `${title}` : '通话';
}

router.beforeEach((to, from, next) => {
  // 如果路由对应的meta信息中有title字段，则设置文档标题
  if (to.meta.title) {
    setPageTitle(to.meta.title as any);
  }
  next();
});
export default router
